export default __webpack_public_path__ + "static/industry-transport-7ad1e24bcb6aaa7a6b3f9f956ab50ddb.webp";